import { Typography } from '@/components/common';
import clsx from 'clsx';
import * as React from 'react';

interface CaseMetricsPyramidProps {
	level: string;
	amount: number;
}

export const CaseMetricsPyramid: React.FC<CaseMetricsPyramidProps> = ({
	level,
	amount,
}) => {
	return (
		<div className="-mt-2 relative">
			<div
				className={clsx(
					'absolute z-10 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-center',
					level === '4' ? 'top-1/3' : 'top-1/2'
				)}
			>
				<Typography type="semibold-20" className="text-[#322935]">
					{amount || '0'}
				</Typography>
			</div>
			{level === '4' ? (
				<svg
					width="106"
					height="93"
					viewBox="0 0 106 93"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<g filter="url(#filter0_d_9970_221334)">
						<path
							d="M56.5198 83.2025C54.9532 85.7868 51.1957 85.7732 49.6521 83.1751L6.15281 9.95837C4.56868 7.29202 6.49024 3.91528 9.59167 3.91528H96.7523C99.805 3.91528 101.73 7.19675 100.228 9.85416C85.869 35.2519 71.4677 58.5438 56.5198 83.2025Z"
							fill="url(#paint0_linear_9970_221334)"
						/>
						<path
							d="M56.0923 82.9433C54.7209 85.2055 51.4324 85.1927 50.082 82.9197L6.58266 9.70298C5.19656 7.36993 6.87792 4.41528 9.59167 4.41528H96.7523C99.4244 4.41528 101.105 7.286 99.7925 9.60809C87.9805 30.5011 76.1404 49.9675 63.9858 69.9509C61.3701 74.2513 58.7399 78.5756 56.0923 82.9433Z"
							stroke="white"
						/>
					</g>
					<defs>
						<filter
							id="filter0_d_9970_221334"
							x="0.585449"
							y="0.915283"
							width="105.164"
							height="91.2169"
							filterUnits="userSpaceOnUse"
							color-interpolation-filters="sRGB"
						>
							<feFlood flood-opacity="0" result="BackgroundImageFix" />
							<feColorMatrix
								in="SourceAlpha"
								type="matrix"
								values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
								result="hardAlpha"
							/>
							<feOffset dy="2" />
							<feGaussianBlur stdDeviation="2.5" />
							<feComposite in2="hardAlpha" operator="out" />
							<feColorMatrix
								type="matrix"
								values="0 0 0 0 0.501961 0 0 0 0 0.223529 0 0 0 0 0.87451 0 0 0 0.32 0"
							/>
							<feBlend
								mode="normal"
								in2="BackgroundImageFix"
								result="effect1_dropShadow_9970_221334"
							/>
							<feBlend
								mode="normal"
								in="SourceGraphic"
								in2="effect1_dropShadow_9970_221334"
								result="shape"
							/>
						</filter>
						<linearGradient
							id="paint0_linear_9970_221334"
							x1="110.458"
							y1="39.8926"
							x2="-8.85059"
							y2="39.8926"
							gradientUnits="userSpaceOnUse"
						>
							<stop stop-color="#C5B1E1" />
							<stop offset="1" stop-color="#C8B3E7" />
						</linearGradient>
					</defs>
				</svg>
			) : level === '3' ? (
				<svg
					width="186"
					height="70"
					viewBox="0 0 186 70"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<g filter="url(#filter0_d_9970_221333)">
						<path
							d="M149.006 60.9871C148.282 62.1841 146.984 62.9153 145.585 62.9153H41.1164C39.7276 62.9153 38.4381 62.1949 37.7101 61.0121L6.3156 10.0122C4.67505 7.34709 6.59241 3.91528 9.72194 3.91528H176.464C179.581 3.91528 181.5 7.32126 179.886 9.98705L149.006 60.9871Z"
							fill="url(#paint0_linear_9970_221333)"
						/>
						<path
							d="M148.579 60.7281C147.944 61.7755 146.809 62.4153 145.585 62.4153H41.1164C39.9012 62.4153 38.7729 61.7849 38.1358 60.75L6.74139 9.75005C5.30591 7.41812 6.9836 4.41528 9.72194 4.41528H176.464C179.191 4.41528 180.871 7.39551 179.458 9.72808L148.579 60.7281Z"
							stroke="white"
						/>
					</g>
					<defs>
						<filter
							id="filter0_d_9970_221333"
							x="0.715576"
							y="0.915283"
							width="184.755"
							height="69"
							filterUnits="userSpaceOnUse"
							color-interpolation-filters="sRGB"
						>
							<feFlood flood-opacity="0" result="BackgroundImageFix" />
							<feColorMatrix
								in="SourceAlpha"
								type="matrix"
								values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
								result="hardAlpha"
							/>
							<feOffset dy="2" />
							<feGaussianBlur stdDeviation="2.5" />
							<feComposite in2="hardAlpha" operator="out" />
							<feColorMatrix
								type="matrix"
								values="0 0 0 0 0.501961 0 0 0 0 0.223529 0 0 0 0 0.87451 0 0 0 0.32 0"
							/>
							<feBlend
								mode="normal"
								in2="BackgroundImageFix"
								result="effect1_dropShadow_9970_221333"
							/>
							<feBlend
								mode="normal"
								in="SourceGraphic"
								in2="effect1_dropShadow_9970_221333"
								result="shape"
							/>
						</filter>
						<linearGradient
							id="paint0_linear_9970_221333"
							x1="198.246"
							y1="31.596"
							x2="-15.196"
							y2="31.596"
							gradientUnits="userSpaceOnUse"
						>
							<stop stop-color="#CCB8DF" />
							<stop offset="1" stop-color="#D0BAF7" />
						</linearGradient>
					</defs>
				</svg>
			) : level === '2' ? (
				<svg
					width="260"
					height="66"
					viewBox="0 0 260 66"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<g filter="url(#filter0_d_9970_221332)">
						<path
							d="M6.16548 9.96264C4.57692 7.29635 6.49816 3.91528 9.60181 3.91528L250.458 3.91528C253.575 3.91528 255.495 7.32419 253.877 9.98991L225.366 56.9899C224.641 58.1853 223.344 58.9153 221.946 58.9153L37.6041 58.9153C36.1947 58.9153 34.8892 58.1735 34.1678 56.9626L6.16548 9.96264Z"
							fill="url(#paint0_linear_9970_221332)"
						/>
						<path
							d="M6.59502 9.70672C5.20503 7.37371 6.88612 4.41528 9.60181 4.41528L250.458 4.41528C253.186 4.41528 254.865 7.39807 253.45 9.73058L224.939 56.7306C224.304 57.7765 223.169 58.4153 221.946 58.4153L37.6041 58.4153C36.3709 58.4153 35.2286 57.7662 34.5974 56.7067L6.59502 9.70672Z"
							stroke="white"
						/>
					</g>
					<defs>
						<filter
							id="filter0_d_9970_221332"
							x="0.595703"
							y="0.915283"
							width="258.868"
							height="65"
							filterUnits="userSpaceOnUse"
							color-interpolation-filters="sRGB"
						>
							<feFlood flood-opacity="0" result="BackgroundImageFix" />
							<feColorMatrix
								in="SourceAlpha"
								type="matrix"
								values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
								result="hardAlpha"
							/>
							<feOffset dy="2" />
							<feGaussianBlur stdDeviation="2.5" />
							<feComposite in2="hardAlpha" operator="out" />
							<feColorMatrix
								type="matrix"
								values="0 0 0 0 0.501961 0 0 0 0 0.223529 0 0 0 0 0.87451 0 0 0 0.32 0"
							/>
							<feBlend
								mode="normal"
								in2="BackgroundImageFix"
								result="effect1_dropShadow_9970_221332"
							/>
							<feBlend
								mode="normal"
								in="SourceGraphic"
								in2="effect1_dropShadow_9970_221332"
								result="shape"
							/>
						</filter>
						<linearGradient
							id="paint0_linear_9970_221332"
							x1="290.63"
							y1="33.9934"
							x2="-31.1407"
							y2="33.9934"
							gradientUnits="userSpaceOnUse"
						>
							<stop stop-color="#C4BEEA" />
							<stop offset="1" stop-color="#E2D0FE" />
						</linearGradient>
					</defs>
				</svg>
			) : level === '1' ? (
				<svg
					width="338"
					height="68"
					viewBox="0 0 338 68"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<g filter="url(#filter0_d_9970_221331)">
						<path
							d="M6.16836 9.9636C4.57879 7.29732 6.49997 3.91528 9.60412 3.91528L328.457 3.91528C331.575 3.91528 333.494 7.32436 331.877 9.99008L302.149 58.9901C301.424 60.1854 300.127 60.9153 298.729 60.9153L38.8168 60.9153C37.4077 60.9153 36.1026 60.1739 35.381 58.9636L6.16836 9.9636Z"
							fill="url(#paint0_linear_9970_221331)"
						/>
						<path
							d="M6.59783 9.70756C5.20696 7.37457 6.88799 4.41528 9.60412 4.41528L328.457 4.41528C331.185 4.41528 332.865 7.39822 331.449 9.73073L301.721 58.7307C301.087 59.7766 299.952 60.4153 298.729 60.4153L38.8168 60.4153C37.5839 60.4153 36.4419 59.7666 35.8105 58.7076L6.59783 9.70756Z"
							stroke="white"
						/>
					</g>
					<defs>
						<filter
							id="filter0_d_9970_221331"
							x="0.5979"
							y="0.915283"
							width="336.865"
							height="67"
							filterUnits="userSpaceOnUse"
							color-interpolation-filters="sRGB"
						>
							<feFlood flood-opacity="0" result="BackgroundImageFix" />
							<feColorMatrix
								in="SourceAlpha"
								type="matrix"
								values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
								result="hardAlpha"
							/>
							<feOffset dy="2" />
							<feGaussianBlur stdDeviation="2.5" />
							<feComposite in2="hardAlpha" operator="out" />
							<feColorMatrix
								type="matrix"
								values="0 0 0 0 0.501961 0 0 0 0 0.223529 0 0 0 0 0.87451 0 0 0 0.32 0"
							/>
							<feBlend
								mode="normal"
								in2="BackgroundImageFix"
								result="effect1_dropShadow_9970_221331"
							/>
							<feBlend
								mode="normal"
								in="SourceGraphic"
								in2="effect1_dropShadow_9970_221331"
								result="shape"
							/>
						</filter>
						<linearGradient
							id="paint0_linear_9970_221331"
							x1="343.751"
							y1="35.8698"
							x2="-14.8267"
							y2="35.8698"
							gradientUnits="userSpaceOnUse"
						>
							<stop stop-color="#D6D1FF" />
							<stop offset="1" stop-color="#E8D8FF" />
						</linearGradient>
					</defs>
				</svg>
			) : level === '0' ? (
				<svg
					width="414"
					height="68"
					viewBox="0 0 414 68"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<g filter="url(#filter0_d_9970_221330)">
						<path
							d="M404.457 3.91528C407.575 3.91528 409.494 7.32433 407.877 9.99004L378.15 58.99C377.424 60.1853 376.128 60.9153 374.73 60.9153L38.8186 60.9153C37.4095 60.9153 36.1044 60.1739 35.3828 58.9637L6.16861 9.96368C4.57896 7.29741 6.50012 3.91528 9.60431 3.91528L404.457 3.91528Z"
							fill="url(#paint0_linear_9970_221330)"
						/>
						<path
							d="M404.457 4.41528C407.185 4.41528 408.865 7.39819 407.45 9.7307L377.722 58.7307C377.088 59.7766 375.953 60.4153 374.73 60.4153L38.8186 60.4153C37.5857 60.4153 36.4437 59.7666 35.8123 58.7076L6.59807 9.70763C5.20713 7.37465 6.88815 4.41528 9.60431 4.41528L404.457 4.41528Z"
							stroke="white"
						/>
					</g>
					<defs>
						<filter
							id="filter0_d_9970_221330"
							x="0.598145"
							y="0.915283"
							width="412.865"
							height="67"
							filterUnits="userSpaceOnUse"
							color-interpolation-filters="sRGB"
						>
							<feFlood flood-opacity="0" result="BackgroundImageFix" />
							<feColorMatrix
								in="SourceAlpha"
								type="matrix"
								values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
								result="hardAlpha"
							/>
							<feOffset dy="2" />
							<feGaussianBlur stdDeviation="2.5" />
							<feComposite in2="hardAlpha" operator="out" />
							<feColorMatrix
								type="matrix"
								values="0 0 0 0 0.501961 0 0 0 0 0.223529 0 0 0 0 0.87451 0 0 0 0.32 0"
							/>
							<feBlend
								mode="normal"
								in2="BackgroundImageFix"
								result="effect1_dropShadow_9970_221330"
							/>
							<feBlend
								mode="normal"
								in="SourceGraphic"
								in2="effect1_dropShadow_9970_221330"
								result="shape"
							/>
						</filter>
						<linearGradient
							id="paint0_linear_9970_221330"
							x1="459.755"
							y1="44.2236"
							x2="-25.4927"
							y2="44.2236"
							gradientUnits="userSpaceOnUse"
						>
							<stop stop-color="#E3E0FF" />
							<stop offset="1" stop-color="#ECE1FD" />
						</linearGradient>
					</defs>
				</svg>
			) : null}
		</div>
	);
};
